const pigmented = [

        {label:"Site(s)",
        controlType:"text area",
        options:[]
        },
    
        {label:"Size",
        controlType:"number",
        options:[]
        },
    
        { 
        label:"Use info from checklist:",
        controlType:"radio button",
        options:["Yes", "No"]
        },
    
        
        {label:"Description",
        controlType:"text area",
        options:[]
        },
    
        {label:"Present for several:",
        controlType:"radio button",
        options:["Days", "Weeks","Months","Years"]
        }
    ]
    
    export default pigmented